<template>
    <v-row no-gutters>
        <v-col cols="12" v-if="charges.length === 0">
            <v-alert border="top" outlined icon="mdi-scale-balance">
                No Crime Records Found
            </v-alert>
        </v-col>
        <template v-for="(charge, index) in charges">
            <v-col lg="4" md="3" sm="6" :key="index">
                <screen-charge :charge="charge" mode="print"></screen-charge>
            </v-col>
        </template>
    </v-row>
</template>
<script>
import WithCrimeRecords from "@components/screen/mixins/WithCrimeRecords";
export default {
    name: "applicant-crimes",
    components: {
        ScreenCharge: () =>
            import("@components/screen/components/Search/ScreenCharge"),
    },
    mixins: [WithCrimeRecords],
    props: {
        crimes: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {};
    },
    computed: {},
    watch: {},
    created() {
        this.records = this.crimes;
    },
};
</script>

<style scoped>
</style>